import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClothing = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1838_366)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_1838_366",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 16,
			height: 16,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M16 0H0V16H16V0Z",
				fill: "white"
			})
		}), /* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_1838_366)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M6 0.5H14C14.8284 0.5 15.5 1.17157 15.5 2V10.6667C15.5 11.4951 14.8284 12.1667 14 12.1667H6C5.17157 12.1667 4.5 11.4951 4.5 10.6667V2C4.5 1.17157 5.17157 0.5 6 0.5Z",
					stroke: "#1A1A1A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M4.44453 3.33325H2.66675C1.56218 3.33325 0.666748 4.22868 0.666748 5.33325V13.3332C0.666748 14.4378 1.56218 15.3332 2.66675 15.3332H10.0001C11.1047 15.3332 12.0001 14.4378 12.0001 13.3332V11.8596",
					stroke: "#1A1A1A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.3334 0C13.3334 1.84095 11.8411 3.33333 10.0001 3.33333C8.15914 3.33333 6.66675 1.84095 6.66675 0",
					stroke: "black"
				})
			]
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1838_366",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgClothing;
